/* global MEDIA_FETCH_COUNT: true */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { createPaginationContainer, graphql } from 'react-relay';

import MediaList from './MediaList';

class FaceMediaList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFetching: false,
    };
  }

  handleLoadMore = () => {
    if (this.props.relay.isLoading()) {
      return;
    }
    this.setState({ isFetching: true });
    this.props.relay.loadMore(MEDIA_FETCH_COUNT, () => this.setState({ isFetching: false }));
  };

  render() {
    const { isFetching } = this.state;
    const {
      eventHasSearchByFace,
      eventHasSecondFactor,
      faceMedia,
      relay,
      offer,
      participantMediaCount,
      impressionMediaCount,
      startnumber,
    } = this.props;

    return (
      <MediaList
        eventHasSearchByFace={eventHasSearchByFace}
        eventHasSecondFactor={eventHasSecondFactor}
        media={faceMedia.mediaList}
        hasMore={relay.hasMore()}
        isFetching={isFetching}
        onLoadMore={this.handleLoadMore}
        offer={offer}
        participantMediaCount={participantMediaCount}
        impressionMediaCount={impressionMediaCount}
        listType="face"
        startnumber={startnumber}
      />
    );
  }
}

FaceMediaList.propTypes = {
  eventHasSearchByFace: PropTypes.bool,
  eventHasSecondFactor: PropTypes.bool,
  participantMediaCount: PropTypes.number,
  impressionMediaCount: PropTypes.number,
  startnumber: PropTypes.string,
  faceMedia: PropTypes.object,
  offer: PropTypes.object,
  relay: PropTypes.object,
};

export { FaceMediaList };

export default createPaginationContainer(
  FaceMediaList,
  {
    faceMedia: graphql`
      fragment FaceMediaList_faceMedia on ExtendedMediaConnection {
        mediaList(first: $count, after: $cursor)
          @connection(key: "FaceMediaList_mediaList") {
          edges {
            node {
              id
            }
          }
          pageInfo {
            hasNextPage
            endCursor
          }
          ...MediaList_media
        }
      }
    `,
    offer: graphql`
      fragment FaceMediaList_offer on Event {
        ...MediaList_offer
      }
    `,
  },
  {
    direction: 'forward',
    // Function that should indicate which connection to paginate over, given the fragment
    // props.
    getConnectionFromProps(props) {
      return props.faceMedia && props.faceMedia.mediaList;
    },
    getFragmentVariables(prevVars, totalCount) {
      return {
        ...prevVars,
        count: totalCount,
      };
    },
    getVariables(props, paginationInfo, fragmentVariables) {
      return {
        eventId: props.eventId,
        startnumber: props.startnumber,
        faceStartnumber: props.faceStartnumber,
        count: paginationInfo.count,
        cursor: paginationInfo.cursor,
      };
    },
    query: graphql`
      query FaceMediaListPaginationQuery(
        $eventId: ID!
        $startnumber: ID!
        $faceStartnumber: ID!
        $count: Int!
        $cursor: String
      ) {
        viewer {
          event(id: $eventId) {
            searchMediaByFace(face: $faceStartnumber, startnumber: $startnumber) {
              ...FaceMediaList_faceMedia
            }
          }
        }
      }
    `,
  },
);
